import { Col, Row } from 'react-styled-flexboxgrid';
import styled from 'styled-components';

import { media } from '@savgroup-front-common/constants';
import { getCustomComponentProperty } from '@savgroup-front-common/core/helpers';
import { transparentize } from '@savgroup-front-common/primitive/helpers/cssColor';
import { rem } from '@savgroup-front-common/primitive/helpers/units';
import { SUPPORTED_PROPERTIES } from '@savgroup-front-common/types';

export const $RowContainer = styled(Row)`
  display: flex;
  align-items: stretch;
`;

export const $ColSvgItem = styled(Col)`
  padding-left: unset;
  padding-right: unset;
  svg {
    width: 48px !important;
    height: 48px !important;
  }
`;

export const $Footer = styled.footer<{
  $enableServicePortal?: boolean;
}>`
  width: 100%;
  padding: ${({ $enableServicePortal }) =>
    $enableServicePortal
      ? `${rem(7)} 0px ${rem(7)} 0px`
      : `${rem(7)} 24px ${rem(7)} 24px`};
  position: ${({ $enableServicePortal }) =>
    $enableServicePortal ? 'relative' : 'fixed'};
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  z-index: 30;
  background-color: ${({ theme }) => {
    return getCustomComponentProperty({
      theme,
      property: SUPPORTED_PROPERTIES.BACKGROUND_COLOR,
      fallback: theme.colors.white,
    });
  }};
  border-top: ${({ theme, $enableServicePortal }) => {
    if ($enableServicePortal) {
      return 'unset';
    }

    return `${theme.borders.thickness} solid ${transparentize(
      0.75,
      theme.colors.default,
    )}`;
  }};
  margin-top: ${rem(42)};
  box-shadow: ${({ $enableServicePortal }) =>
    $enableServicePortal ? 'unset' : '0 -2px 10px rgba(104, 154, 186, 0.1)'};
  @media ${media.maxWidth.sm} {
    margin-top: ${rem(14)};
    height: unset;
  }
`;

export const $RowFooter = styled(Row)`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-right: unset;
  margin-left: unset;
  flex-direction: row;

  @media ${media.maxWidth.sm} {
    flex-direction: row;
  }
`;
